/**
 * CDU create/update payload helpers (#996 Phase 2).
 */

import type { LiquidCoolingCduConfiguration } from '../types/liquidCoolingCdu';

/** Strip server metadata before POST /requests/:id/liquid-cooling-cdus */
export function toCreateLiquidCoolingCduPayload(
  unit: LiquidCoolingCduConfiguration,
): Omit<LiquidCoolingCduConfiguration, 'id' | 'createdAt' | 'updatedAt'> {
  const {
    id: _id,
    createdAt: _createdAt,
    updatedAt: _updatedAt,
    ...payload
  } = unit;
  return payload;
}
